export enum SubscriptionStatusEnum {
    Active = 155,
    Cancelled = 156,
    Pending = 157
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/subscription-status.enum.ts